export default __webpack_public_path__ + "static/featuredImage-b36e56759f71fd9eb1fcdca7e641f954.jpg";